const input = {
    username: 'Username',
    password: 'Password',
    email: 'อีเมล',
    phone_number: 'หมายเลขโทรศัพท์',
    student_number: 'รหัสนักศึกษา',
    registration_number: 'หมายเลขลงทะเบียน',
    student_identifier_legend: 'เข้าสู่ระบบด้วย',
    confirm_password: 'ยืนยันรหัสผ่าน',
    search_region_code: 'ค้นหารหัสภูมิภาค',
    backup_code: 'รหัสสำรอง',
    code: 'รหัส',
    label_with_optional: '{{label}} (ไม่บังคับ)',
};
export default Object.freeze(input);
